import React from "react";
import { ConfirmationModalWindow } from "./../../ConfirmationModalWindow";
import { NotificationToaster } from "./../../NotificationToaster";
import { getCurrentPeriodEnd } from "./../../../helpers/functions";
import { Type } from "discover.medical.react-component-library";

export const AutoRenew = ({
  subscriptionDetails,
  setShowModal,
  isOpenedModal,
  handleSwitchAutoRenewSubmit,
  showToast,
  message,
}) => (
  <section className="my-subscription__auto-renew">
    <Type element="p" marginBottom="sm">
      {`Your subscription will ${subscriptionDetails.cancelAtPeriodEnd ? "expire" : "auto-renew"} on ${`${getCurrentPeriodEnd("day", subscriptionDetails.currentPeriodEnd)} ${getCurrentPeriodEnd("month", subscriptionDetails.currentPeriodEnd)} ${getCurrentPeriodEnd("year", subscriptionDetails.currentPeriodEnd)}`}`}
    </Type>
    {subscriptionDetails.cancelAtPeriodEnd ? null : (
      <button
        className="my-subscription__auto-renew-turn-off"
        onClick={() => setShowModal(true)}
      >
        Turn off auto-renew
      </button>
    )}
    <ConfirmationModalWindow
      isOpenedModal={isOpenedModal}
      handleContinueButtonClick={handleSwitchAutoRenewSubmit}
      handleCancelButtonClick={() => setShowModal(false)}
      message={`Are you sure you want to turn off auto-renew?`}
    />
    <NotificationToaster
      isOpen={showToast.show}
      message={message}
      type={showToast.type}
    />
  </section>
);
